/**
 * Presets that create items for root and node specific context menu.
 * @module
 */

export * as classic from './classic'
